"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKeyResettable = void 0;
const KHInputKeyDerived_1 = require("./KHInputKeyDerived");
/**
 * An input key that can be manually reset. If reset, the underlying input key
 * must be unpressed and repressed before it will be considered down again.
 */
class KHInputKeyResettable extends KHInputKeyDerived_1.KHInputKeyDerived {
    constructor(inputSet, source) {
        super(inputSet);
        this.source = source;
    }
    reset() {
        this.requiresReset = true;
        super.update(false);
    }
    updateDerivedInput() {
        this.requiresReset = this.requiresReset && this.source.isDown();
        super.update(this.source.isDown() && !this.requiresReset);
    }
    update(down) {
        // Clear requires reset if no longer down.
        this.requiresReset = this.requiresReset && down;
        super.update(down && !this.requiresReset);
    }
}
exports.KHInputKeyResettable = KHInputKeyResettable;
